module.exports = __webpack_public_path__ + "public/SideMenuIcons/mobileSetting.svg?1df50110";